/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove track" |
*
* @param {Audio_Embed_Export_Output_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_remove = /** @type {((inputs?: Audio_Embed_Export_Output_RemoveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_RemoveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spur entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить трек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("曲目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover faixa")
	return /** @type {LocalizedString} */ ("Remove track")
});